import { NotFoundContainer } from './NotFoundContainer';

const name = 'NotFoundContainer';

export { name, NotFoundContainer };
